import d from "./DOM.js";
import { withCsrf } from "./csrf.js";

export default abstract class journal {
	public static init() {
		d.e('click', journal.journalBtnClickHandler, d.qsa<HTMLButtonElement>('.journalBtn'));
		d.e('change', journal.handlePaginationChange, d.qs<HTMLSelectElement>('.pagination-select'));
		d.qs<HTMLSelectElement>('.pagination-select').value = new URLSearchParams(window.location.search).get('limit') || '5';
	}
	
	private static journalBtnClickHandler(e: MouseEvent) {
		d.action(<EventTarget>e.target, '.journalBtn', action => {
			if (action === 'add') { journal.openAddTradeModal(); }
			else if (action == 'prev') { journal.goPrevPage(); }
			else if (action == 'next') { journal.goNextPage(); }
		});
	}
	
	private static async handlePaginationChange() {
		const limitSelect = d.qs<HTMLSelectElement>('.pagination-select');
		const limit = limitSelect ? parseInt(limitSelect.value, 10) : 5;
		const urlParams = new URLSearchParams(window.location.search);
		
		urlParams.set('limit', limit.toString());
		urlParams.set('page', '1');
		
		window.location.search = urlParams.toString();
	}
	
	private static goNextPage() {
		const urlParams = new URLSearchParams(window.location.search);
		const currentPage = parseInt(urlParams.get('page') || '1', 10);
		const totalPages = parseInt(d.qs<HTMLInputElement>('#totalPages')?.value || '1', 10);
		if (currentPage >= totalPages) { return; }
		
		urlParams.set('page', (currentPage + 1).toString());
		window.location.search = urlParams.toString();
	}
	
	private static goPrevPage() {
		const urlParams = new URLSearchParams(window.location.search);
		const currentPage = parseInt(urlParams.get('page') || '1', 10);
		
		if (currentPage > 1) {
			urlParams.set('page', (currentPage - 1).toString());
			window.location.search = urlParams.toString();
		}
	}
	
	private static openAddTradeModal() {
		const modal = d.qs<HTMLDivElement>('#tradeModal');
		
		if (modal) {
			modal.classList.remove('hidden');
			const dateInput = modal.querySelector<HTMLInputElement>('input[name="entryDate"]');
			
			if (dateInput && !dateInput.value) {
				const now = new Date();
				now.setMinutes(now.getMinutes() - now.getTimezoneOffset());
				dateInput.value = now.toISOString().slice(0, 16);
			}
			
			setTimeout(() => { modal.classList.add('open'); }, 250);
			
			d.e('click', journal.tradeModalBtnClickHandler, d.qsa<HTMLButtonElement>('.tradeModalBtn'));
			d.e('click', journal.modalOverlayClickHandler, modal);
		}
	}
	
	private static modalOverlayClickHandler(e: MouseEvent) {
		if (e.target === e.currentTarget) {
			journal.closeTradeModal();
		}
	}
	
	private static tradeModalBtnClickHandler(e: MouseEvent) {
		d.action(<EventTarget>e.target, '.tradeModalBtn', action => {
			if (action === 'close') { journal.closeTradeModal(); }
			else if (action === 'save') { journal.saveTradeEntry(); }
		});
	}
	
	private static closeTradeModal() {
		const modal = d.qs<HTMLDivElement>('#tradeModal');
		
		if (modal) {
			modal.classList.remove('open');
			d.qs<HTMLFormElement>('#addTradeForm')?.reset();
			setTimeout(() => { modal.classList.add('hidden'); }, 250);
		}
	}
	
	private static async saveTradeEntry() {
		const form = d.qs<HTMLFormElement>('#addTradeForm');
		if (!form) { return; }
		
		const formData = new FormData(form);
		const data = Object.fromEntries((<any>formData).entries());
		
		if (data.stopLossPrice === '') { delete data.stopLossPrice; }
		if (data.takeProfitPrice === '') { delete data.takeProfitPrice; }
		
		try {
			const res = await fetch('/api/journal', {
				method: 'POST',
				headers: withCsrf({ 'Content-Type': 'application/json' }),
				body: JSON.stringify(data)
			});
			
			const result = await res.json();
			
			if (res.ok) { window.location.reload(); }
			else { alert('Error: ' + (result.error || 'Failed to save trade')); }
		} catch (error) {
			console.error(error);
			alert('Network error occurred.');
		}
	}
}
